<!-- header start -->
<app-header-one [transparent]="true" [white_bg]="true"></app-header-one>
<!-- header end -->

<main>

  <!-- breadcrumb start -->
  <app-breadcrumb-one title="Account" subtitle="Account"></app-breadcrumb-one>
  <!-- breadcrumb end -->

  <!-- profile area start -->
  <section class="profile__area pt-120 pb-50 grey-bg">
    <div class="container">
      <div class="profile__basic-inner pb-20 bg-white">
        <div class="row align-items-center">
          <div class="col-xxl-6 col-md-6">
            <div class="profile__basic d-md-flex align-items-center">
              <!-- <div class="profile__basic-thumb mr-30">
                <img src="/assets/img/testimonial/person-1.jpg" alt="">
              </div> -->
              <div class="profile__basic-content">
                <h3 class="profile__basic-title" *ngIf="authUser">
                  Welcome Back <span>{{ authUser.first_name+' '+authUser.last_name }}</span>
                </h3>
                <!-- <p>2 Running Courses <a routerLink="/home/home-style-1">View Course</a></p> -->
              </div>
            </div>
          </div>
          <div class="col-xxl-6 col-md-6">
            <div class="profile__basic-cart d-flex align-items-center justify-content-md-end">
              <div class="cart-info mr-10">
                <a routerLink="/shop/cart">View cart</a>
              </div>
              <div class="cart-item">
                <a routerLink="/shop/cart">
                  <i class="fa-regular fa-basket-shopping"></i>
                  <span class="cart-quantity">2</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- profile area end -->

  <!-- profile menu area start -->
  <section class="profile__menu pb-70 grey-bg">
    <div class="container">
      <div class="row">
        <div class="col-xxl-4 col-md-4">
          <div class="profile__menu-left bg-white mb-50">
            <h3 class="profile__menu-title"><i class="fa fa-list-alt"></i> Your Menu</h3>
            <div class="profile__menu-tab">
              <div class="nav nav-tabs flex-column justify-content-start text-start" id="nav-tab" role="tablist">
                <button class="nav-link active" id="nav-account-tab" data-bs-toggle="tab" data-bs-target="#nav-account" type="button" role="tab" aria-controls="nav-account" aria-selected="true"> <i class="fa fa-user"></i> My Account </button>

                <button class="nav-link" id="nav-order-tab" data-bs-toggle="tab" data-bs-target="#nav-order" type="button" role="tab" aria-controls="nav-order" aria-selected="false"><i class="fa fa-file"></i> Orders </button>

                <button class="nav-link" id="nav-password-tab" data-bs-toggle="tab" data-bs-target="#nav-password" type="button" role="tab" aria-controls="nav-password" aria-selected="false"><i class="fa fa-lock"></i>Change Password</button>

                <button class="nav-link" (click)="logout()"><i class="fa fa-sign-out"></i> Logout</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-8 col-md-8">
          <div class="profile__menu-right">
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade show active" id="nav-account" role="tabpanel" aria-labelledby="nav-account-tab">
                <div class="profile__info">
                  <div class="profile__info-top d-flex justify-content-between align-items-center">
                    <h3 class="profile__info-title">Profile Information</h3>
                    <button class="profile__info-btn" type="button" data-bs-toggle="modal"
                      data-bs-target="#profile_edit_modal"><i class="fa-regular fa-pen-to-square"></i> Edit Profile</button>
                  </div>

                  <div class="profile__info-wrapper white-bg" *ngIf="authUser">
                    <div class="profile__info-item">
                      <p>Name</p>
                      <h4>{{ authUser.first_name+' '+authUser.last_name }}</h4>
                    </div>
                    <div class="profile__info-item">
                      <p>Email</p>
                      <h4>
                        <a href="mailt:{{ authUser.email }}" class="__cf_email__" data-cfemail="94fdfaf2fbd4f1f0e1fff1e6baf7fbf9">{{ authUser.email }}</a>
                      </h4>
                    </div>
                    <div class="profile__info-item">
                      <p>Phone</p>
                      <h4>{{ authUser.phone }}</h4>
                    </div>
                    <div class="profile__info-item">
                      <p>Address</p>
                      <h4>Abingdon, Maryland(MD), 21009</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="nav-order" role="tabpanel" aria-labelledby="nav-order-tab">
                <div class="order__info">
                  <div class="order__info-top d-flex justify-content-between align-items-center">
                    <h3 class="order__info-title">My Orders</h3>
                    <button type="button" class="order__info-btn">
                      <i class="fa-regular fa-trash-can"></i> Clear
                    </button>
                  </div>

                  <div class="order__list white-bg table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">Order ID</th>
                          <th scope="col">Name</th>
                          <th scope="col">Price</th>
                          <th scope="col">Details</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="order__id">#3520</td>
                          <td><a [routerLink]="['/shop/product']" class="order__title">University seminar series global.</a>
                          </td>
                          <td>$144.00</td>
                          <td><a [routerLink]="['/shop/product']" class="order__view-btn">View</a></td>
                        </tr>
                        <tr>
                          <td class="order__id">#2441</td>
                          <td><a [routerLink]="['/shop/product']" class="order__title">Web coding and apache basics</a></td>
                          <td>$59.54</td>
                          <td><a [routerLink]="['/shop/product']" class="order__view-btn">View</a></td>
                        </tr>
                        <tr>
                          <td class="order__id">#2357</td>
                          <td><a [routerLink]="['/shop/product']" class="order__title">Economics historical development</a>
                          </td>
                          <td>$89.90</td>
                          <td><a [routerLink]="['/shop/product']" class="order__view-btn">View</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="nav-password" role="tabpanel" aria-labelledby="nav-password-tab">
                <div class="password__change">
                  <div class="password__change-top">
                    <h3 class="password__change-title">Change Password</h3>
                  </div>
                  <div class="password__form white-bg">
                    <form action="#">
                      <div class="password__input">
                        <p>Old Password</p>
                        <input type="password" placeholder="Enter Old Password">
                      </div>
                      <div class="password__input">
                        <p>New Password</p>
                        <input type="password" placeholder="Enter New Password">
                      </div>
                      <div class="password__input">
                        <p>Confirm Password</p>
                        <input type="password" placeholder="Confirm Password">
                      </div>
                      <div class="password__input">
                        <button type="submit" class="os-btn os-btn-black">Update password</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- profile menu area end -->

</main>

<!-- footer start -->
<app-footer-one></app-footer-one>
<!-- footer end -->
